<div class="spend-trend-chart" aria-hidden="true">
  <canvas #ctx></canvas>
</div>
